import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, first } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { VerificarViajeForm } from "./form";
const VerificadorViajeFormRx = componentToRx(VerificarViajeForm);
type Entity = models.VerificacionViajeEADDto;
const resource = resources.ViajeEAD;

interface Props {
    match: match<{ id: string }>
}
class VerificadorViajeEditComp extends React.PureComponent<Props> {
    constructor(props: Props) {
        super(props);
    }
    id = (props: Props) => Number.parseInt(props.match.params.id);
    model = createSelectorRx(this.id, id => observeResource(resource.ObtenerModeloVerificacionViaje, id));
    viaje = createSelectorRx(this.id, id => observeResource(resource.GetViaje, id));

    render() {
        const props = this.props;
        const model = this.model(this.props);
        const viaje = this.viaje(this.props);
        return <VerificadorViajeFormRx model={model} viaje={viaje} />;
    }
}

export const VerificadorViajeEdit = withRouter(VerificadorViajeEditComp);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesEAD/verificar/edit.tsx